import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Observable } from '../util/rxjs';
import { LoadingBarEvent, LoadingBarService } from './loading-bar.service';

@Component({
  selector: 'cp-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingBarComponent {
  events$: Observable<LoadingBarEvent>;

  constructor(loadingBarService: LoadingBarService) {
    this.events$ = loadingBarService.events$;
  }

  isProgressEvent(event: LoadingBarEvent) {
    return event.type === 'progress';
  }
}
